import React, { useState } from "react"

import { devicePresetConfigs, DeviceType } from "../types/deviceTypes"

interface DeviceSelectorProps {
  onDeviceSelect: (deviceType: DeviceType) => void
  selectedDeviceType: DeviceType
}

export const DeviceSelector: React.FC<DeviceSelectorProps> = ({
  onDeviceSelect,
  selectedDeviceType,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const selectedConfig = devicePresetConfigs[selectedDeviceType]

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 bg-gray-800 rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <span className="text-gray-300">{selectedConfig.icon}</span>
        <span className="text-sm text-gray-300">{selectedConfig.name}</span>
        <svg
          className={`w-4 h-4 text-gray-400 transform ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute z-10 mt-2 w-48 rounded-md shadow-lg bg-gray-800 ring-1 ring-black ring-opacity-5">
          <div
            className="py-1"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="device-selector"
          >
            {Object.entries(devicePresetConfigs).map(([type, config]) => (
              <button
                key={type}
                className={`w-full text-left px-4 py-2 text-sm ${
                  selectedDeviceType === type
                    ? "bg-gray-700 text-white"
                    : "text-gray-300 hover:bg-gray-700"
                }`}
                role="menuitem"
                onClick={() => {
                  onDeviceSelect(type as DeviceType)
                  setIsOpen(false)
                }}
              >
                <div className="flex items-center space-x-2">
                  <span>{config.icon}</span>
                  <span>{config.name}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export { DeviceType, devicePresetConfigs }
